// 常量相关的文件夹

export const LOGINTOKEN = 'loginToken'

export const lOGINUSERNAME = 'user_name'
export const LOGINPASSPORT = 'passport'

export const needToken = true

export const uiPrefix = "xpy-ui"